import React from 'react';

export const AgeGateContext = React.createContext('regular');
